export class customerData {
  Id_Customer: number = 0;
  Name: string = '';
}
